import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getAdminSensorOrders = async () => {
  const signedRequest = await createSignedGetRequest({
    apiPath: 'admin/renolog/sensor-orders',
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
